
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { User } from '@/models/main';
import { format, utcToZonedTime } from 'date-fns-tz';
import { timeZoneDefault } from '@/utils/PortalConstants';

@Component({
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class DatePicker extends Vue {
  @Prop(Boolean) private readonly disabled!: boolean;
  @Prop(String) private readonly context!: string;
  @Prop(Array) private readonly Pdates!: string[];
  @Prop({ type: Boolean, required: false, default: false }) public todayButton: boolean;

  private user!: User;
  private today = '';
  private menu = false;
  private dates: string[] = [];

  private get dateRangeText(): string {
    return this.dates.sort().join(' - ');
  }
  private set dateRangeText(val: string) {
    this.dates = [];
  }

  private menuClose() {
    if (this.dates.length === 2) {
      this.menu = false;
    }
  }

  @Watch('menu')
  private changeDates() {
    if (!this.menu) {
      this.$emit('changeDate', this.dates);
    }
  }
  private todayClick(): void {
    this.dates = [this.today, this.today];
  }

  private clear() {
    this.dates = [];
    this.changeDates();
    this.$emit('cleareDateFilter');
  }

  @Watch('Pdates', { immediate: true })
  private watchToDateProps() {
    this.dates = this.Pdates;
  }
  private mounted(): void {
    const userTimeZone = this.user.timezone || timeZoneDefault;
    this.today = format(utcToZonedTime(new Date(), userTimeZone), 'yyyy-MM-dd'); // today
  }
}
